import { Article } from '../api/CmsApi';

export default ({ widgets, ...article }: Article): Article => {
  return article;
};
